import type { useSingleton } from "@tippyjs/react";
import { canv } from "@/canv/global";
import { MenuIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar/BottomRightBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    isActive: boolean;
};

export const ContextMenu = ({ singletoneTarget, isActive }: Props) => {
    const openSettingsWindow = () => {
        // TODO: переделать на реакт
        canv.appInterface.settingsWindow.show();
    };
    return (
        <Tooltip singleton={singletoneTarget} content="Меню">
            <BottomBarItem
                className="barPanelSettings"
                active={isActive}
                onClick={openSettingsWindow}
            >
                <MenuIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
